
import { faArrowRightLong } from '@fortawesome/pro-solid-svg-icons'

export default {
  name: 'PageBookIndex',

  props: {
    initialPaddockSlug: {
      type: String,
      default: null
    },

    initialDateTime: {
      type: String,
      default: null
    },

    isBrochureware: {
      type: Boolean,
      default: false
    },

    isInsideModal: {
      type: Boolean,
      default: false
    },

    isStaff: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      bookApi: new this.$ApiModel(),
      basketApi: new this.$ApiModel(),
      initialDate: null,
      isBooking: false,
      faArrowRightLong
    }
  },

  created() {
    this.$store.dispatch('booking/fetchBasket')

    // If no initialDateTime specified, check if we have a query param
    if (
      !this.initialDateTime &&
      this.$route.query?.date &&
      this.$dateNew.fromSQL(this.$route.query.date) >= this.$dateNew.now()
    ) {
      this.initialDate = this.$route.query?.date
    } else {
      this.initialDate = this.initialDateTime
    }
  },

  methods: {
    async book() {
      this.isBooking = true

      try {
        const bookingTimeSplit = this.bookApi.model.startTime.split(':')

        this.bookApi.model.startAt = this.$dateNew
          .fromSQL(this.bookApi.model.startDate)
          .set({
            hour: bookingTimeSplit[0],
            minute: bookingTimeSplit[1]
          })
          .toSQL()

        // Booking returns current basket
        const { response } = await this.$api.booking(this.bookApi).book()

        this.$store.commit('booking/setBasket', { basket: response.data })

        return response.data
      } catch (error) {
        this.$log.error('Error booking', error)

        if (this.bookApi.response.code === 409) {
          this.$modal.open('book/conflict', {}, () => {
            if (this.$refs.form) {
              this.$refs.form.resetAndFetch()
            }
          })
        } else {
          this.$notify.error('Error booking that session, please reload and try again')
        }
      } finally {
        this.isBooking = false
      }
    },

    async bookAndReset() {
      const booking = await this.book()

      if (booking) {
        this.$analytics.addEvent('book and reset')

        this.$refs.form.resetAndFetch()

        this.$notify.success('Booking added to your basket')
      }
    },

    async bookAndCheckout() {
      const booking = await this.book()

      if (booking) {
        this.$analytics.addEvent('book and checkout')

        this.checkout()
      }
    },

    checkout() {
      if (this.$app.isBrochureware) {
        this.$redirect.to('/book/checkout')
      } else if (this.isInsideModal) {
        this.$modal.close('admin/admin-book')
        this.$modal.open('admin/admin-checkout')
      } else {
        this.$redirect.to('/platform/book/checkout')
      }
    }
  }
}
